import { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="fixed bottom-8 right-8 z-50 w-12 h-12 flex items-center justify-center rounded-full transition-all duration-300"
      style={{
        background: "rgba(204,0,0,0.85)",
        border: "1px solid rgba(204,0,0,0.5)",
        backdropFilter: "blur(10px)",
        boxShadow: "0 0 20px rgba(204,0,0,0.4)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transform: visible ? "translateY(0)" : "translateY(20px)",
      }}
    >
      <FaChevronUp className="text-white text-sm" />
    </button>
  );
}
